export enum PluginKey {
  CELL_SELECTION = 'cell-selection',
  COMMENTS = 'comments',
  CONTEXT_MENU = 'context-menu',
  DATABASE_ACTIONS = 'database-actions',
  EDIT_CONTENT = 'edit-content',
  INLINE_DATABASE_NAME = 'inline-database-name',
  QUICK_CALCULATIONS = 'quick-calculations',
  VIEW_SETTINGS_ACTIONS = 'view-settings-actions',
  VIEW_SETTINGS_BUTTONS = 'view-settings-buttons',
}

export type PluginsState = Record<PluginKey, () => boolean>;

export type { PluginsChecker } from './contracts/plugins-checker';
